import { createState } from '@hookstate/core';

interface AdminState {
  selectedCompanyId: string;
}

export const adminState = createState<AdminState>({
  selectedCompanyId: '', // Yes this is little hack, but <PrivateRoute /> handles it
});
